import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import VideoService from "./VideoService";

export const getVideos = createAsyncThunk("Video/get-Videos", async (thunkAPI) => {
  try {
    return await VideoService.getVideos();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createVideos = createAsyncThunk(
  "Video/create-Videos",
  async (VideoData, thunkAPI) => {
    try {
      return await VideoService.createVideos(VideoData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAVideo = createAsyncThunk(
  "Video/get-Video",
  async (id, thunkAPI) => {
    try {
      return await VideoService.getVideo(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAVideo = createAsyncThunk(
  "Video/update-Video",
  async (brand, thunkAPI) => {
    try {
      return await VideoService.updateVideo(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAVideo = createAsyncThunk(
  "Video/delete-Video",
  async (id, thunkAPI) => {
    try {
      return await VideoService.deleteVideo(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Videos: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const VideoSlice = createSlice({
  name: "Video",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVideos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVideos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Videos = action.payload.data;
      })
      .addCase(getVideos.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createVideos.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createVideos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdVideo = action.payload;
      })
      .addCase(createVideos.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getAVideo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAVideo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Videotitle = action.payload.data.title;
        state.VideoVideos = action.payload.data.videos[0];
        
      })
      .addCase(getAVideo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAVideo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAVideo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedVideo = action.payload;
        
       
      })
      .addCase(updateAVideo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAVideo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAVideo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedVideo = action.payload;
      })
      .addCase(deleteAVideo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default VideoSlice.reducer;
